export default { GENERAL_DATA_FETCHING_SUCCESS: 'GENERAL_DATA_FETCHING_SUCCESS' };



// WEBPACK FOOTER //
// ./src/redux/constants/GeneralConstants.js